/**
 * Replies API - Delete Operations
 *
 * Soft-delete functionality for replies.
 */

import { auth } from "../../firebaseConfig";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebaseConfig";

/**
 * Soft-deletes a reply atomically using Cloud Function.
 *
 * PHASE 1 FIX: Now uses Cloud Function with Firestore Transaction for true atomicity.
 * Includes automatic notification cleanup to prevent orphan notifications.
 *
 * @param {string} replyId
 * @param {string} username  Used for legacy ownership check when `userId` is absent.
 * @returns {Promise<true>}
 */
export const deleteReply = async (replyId) => {
  try {
    const currentUid = auth?.currentUser?.uid || null;
    if (!currentUid) {
      throw new Error("You must be logged in to delete a reply");
    }

    // Call atomic Cloud Function for true transactional delete
    const deleteReplyAtomic = httpsCallable(functions, 'deleteReplyAtomic');
    const result = await deleteReplyAtomic({
      replyId,
      requesterId: currentUid
    });

    if (result.data?.success || result.data?.alreadyDeleted) {
      return true;
    } else {
      throw new Error(result.data?.message || "Failed to delete reply");
    }
  } catch (error) {
    console.error("Error deleting reply:", error);
    throw error;
  }
};
